var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Facebook = function Facebook(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M14 2.5A5.5 5.5 0 0 0 8.5 8v1.5H6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.5V21a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-6.5H16a.5.5 0 0 0 .485-.379l1-4A.5.5 0 0 0 17 9.5h-3.5V8a.5.5 0 0 1 .5-.5h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5h-3Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Facebook;